// Primary
export const limeGreen = "hsl(163, 72%, 41%)";
export const brightRed = "hsl(356, 69%, 56%)";
export const facebook = "hsl(208, 92%, 53%)";
export const twitter = "hsl(203, 89%, 53%)";
export const instagram = "#C13584";
export const youtube = "hsl(348, 97%, 39%)";

// Dark Theme toggle
export const toggle = "linear-gradient(90deg, rgba(55,143,230,1) 35%, rgba(62,218,130,1) 100%)";

// Light Theme toggle
export const toggleLight = "hsl(230, 22%, 74%)";

// Neutral
// Dark Theme
export const veryDarkBlueBg = "hsl(230, 17%, 14%)";
export const veryDarkBlueTopBg = "hsl(232, 19%, 15%)";
export const darkDesaturedBlueCardBg = "hsl(228, 28%, 20%)";
export const desaturedBlueText = "hsl(228, 34%, 66%)";
export const whiteText = "hsl(0, 0%, 100%)";

// Light Theme
export const whiteBg = "hsl(0, 0%, 100%)";
export const veryPaleBlueTopBg = "hsl(225, 100%, 98%)";
export const lightGrayishBlueCardBg = "hsl(227, 47%, 96%)";
export const darkGrayishBlueText = "hsl(228, 12%, 44%)";
export const veryDarkBlueText = "hsl(230, 17%, 14%)";

// Typography
// Body Copy
export const fontSizeOverview = "14px";
export const fontFamily = `"Inter", sans-serif`;

// Font
export const weights400 = "400";
export const weights700 = "700";